import { useParams, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import ArticleCard from "@/components/base/ArticleCard";
import ScrollToTop from "@/components/base/ScrollToTop";
import { categories, categoryMap } from "@/mocks/categories";
import { getArticlesByCategory } from "@/mocks/articles";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug);
  const categoryName = slug ? categoryMap[slug] || slug : "";

  const articles = slug ? getArticlesByCategory(slug) : [];

  const [activeSlug, setActiveSlug] = useState(slug || "film");

  useEffect(() => {
    if (slug) setActiveSlug(slug);
  }, [slug]);

  const categoryItemSchema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: `${categoryName} - 苍井优`,
    description: `浏览苍井优的${categoryName}相关内容，了解这位日本实力派女演员的精彩作品与资讯。`,
    url: `https://yuaoi-fans.com/category/${slug}`,
    isPartOf: {
      "@type": "WebSite",
      name: "苍井优中文资讯站",
    },
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(categoryItemSchema),
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          {/* Category Header */}
          <section className="w-full px-6 md:px-10 py-8 md:py-10 bg-background-100">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: categoryName },
              ]}
            />
            <div className="mt-4">
              <h1
                className="text-2xl md:text-3xl font-bold text-foreground-950"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                {categoryName}
              </h1>
              {currentCategory && (
                <p className="text-sm text-foreground-500 mt-2">
                  {currentCategory.description}
                </p>
              )}
            </div>
          </section>

          {/* Category Tabs */}
          <section className="w-full px-6 md:px-10 py-6 bg-background-50 border-b border-background-200/60 sticky top-16 z-40">
            <div className="flex items-center gap-2 overflow-x-auto pb-1">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap ${
                    activeSlug === cat.slug
                      ? "bg-primary-500 text-white"
                      : "bg-background-100 text-foreground-600 hover:bg-background-200"
                  }`}
                >
                  <i className={`${cat.icon} text-sm`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </section>

          {/* Articles Grid */}
          <section className="w-full px-6 md:px-10 py-10 md:py-14">
            {articles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {articles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                  <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-sm text-foreground-500">
                  该分类下暂无文章
                </p>
              </div>
            )}
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}